import React from 'react';

import styles from './styles.module.scss';

const Loader = ({
  onClick,
  children,
  className = styles.lds_ring,
  tabIndex,
  width = 'w-[100vw]',
  height = 'h-[100vh]',
}) => {
  return (
    <div
      className={`flex flex-row justify-center items-center ${width} ${height} `}
    >
      {/* <div className={`${className} `}> */}
      <span className={`loader ${className}`}></span>
      {/* //     <div className="mainLoaderColor"></div>
    //     <div className="mainLoaderColor"></div>
    //     <div className="mainLoaderColor"></div>
    //     <div className="mainLoaderColor"></div> */}
      {/* </div> */}
    </div>
  );
};

export default Loader;
